import HSNType from "../types/HSNType";
import HSNAction from "../actions/HSNAction";

interface HSNAction {
  type: string;
  payload?: any;
}

const initial_state = {
  hsnList: [],
};

const HSNReducer = (state = initial_state, action: HSNAction) => {
  switch (action.type) {
    case HSNType.GET_HSN_LIST:
      return {
        ...state,
        hsnList: action.payload,
      };

    default:
      return state;
  }
};

export default HSNReducer;
